import { PermissionArrayType } from '../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';

export const ataPermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
    ...getAllPermissionRolesForUserLevel('customer'),
  ],
  UPDATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
    ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
  ],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin],
};

export const ataDownloadConfigPermissions = [
  PERMISSIONROLECONSTANTS.superadmin,
  ...getAllPermissionRolesForUserLevel('telcloud', ['admin']),
];

export const ataBulkRebootPermissions: string[] = [
  PERMISSIONROLECONSTANTS.superadmin,
  ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
  ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
  ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
];
